<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Prep Process Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="New Prep Process" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add prep process'">
      <template #gated-content>
        <prep-process-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import PrepProcessForm from "@/components/lab/prepprocess/PrepProcessForm";
import { notificationOptions } from "@/shared/toast-notification-options";
import { prepProcessNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getModel } from "@/shared/fetch-utils";

const PrepProcessRepository = LabRepositoryFactory.get("prepProcess");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "PrepProcessAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    PrepProcessForm,
  },
  data() {
    return {
      loading: true,
      laboratory_id: this.$store.getters.getLaboratoryContext.id || null,
      prep_workflow_id: this.$route.params.test_workflow_id || null,
      prep_workflow: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/prep-workflows",
            title: "Prep Process list",
          },
        ],
      };
    },
  },
  methods: {
    async init() {
      this.prep_workflow_id &&
        (this.prep_workflow = await getModel({
          model_type: "prep_workflow",
          id: this.test_workflow_id,
          message: this.$bvToast,
        }));

      this.loading = false;
    },
    async submit(form_data) {
      try {
        await PrepProcessRepository.create({
          ...form_data,
          laboratory_id: this.laboratory_id,
        });
        this.addSuccess();

        this.$router.push("/prep-workflows/");
      } catch ({ response }) {
        this.$bvToast.toast(
          `Code: ${response.status}. ${response.data.error}`,
          {
            title: "Process creation Failed.",
            variant: "danger",
          }
        );
      }
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
  notifications: prepProcessNotifications,
};
</script>
